"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceFormatter = void 0;
const _1 = require(".");
const priceFormatter = (price, options = {}) => {
    const { showZero = false, currencyOptions = _1.CURRENCY_FORMAT_OPTIONS, locale = _1.DEFAULT_LOCALE } = options;
    if (price === null || price === undefined) {
        return '-';
    }
    if (!showZero && price === 0) {
        return '-';
    }
    const parsedPrice = typeof price === 'string' ? parseFloat(price) : price;
    return parsedPrice.toLocaleString(locale, Object.assign(Object.assign({}, _1.CURRENCY_FORMAT_OPTIONS), currencyOptions));
};
exports.priceFormatter = priceFormatter;
